export default "__VITE_ASSET__Cca$yiOI__"